import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import { useAuth } from '@/contexts/AuthContext';
import { Crown, ArrowRight } from 'lucide-react-native';

interface PremiumCTAProps {
    compact?: boolean;
}

export default function PremiumCTA({ compact = false }: PremiumCTAProps) {
    const { colors } = useTheme();
    const { isPremium } = useAuth();
    const router = useRouter();

    if (isPremium()) {
        return null;
    }

    const handlePress = () => {
        router.push('/(tabs)/assinatura');
    };

    if (compact) {
        return (
            <TouchableOpacity
                style={[styles.containerCompact, { backgroundColor: colors.surface, borderColor: colors.warning }]}
                onPress={handlePress}
                activeOpacity={0.8}
            >
                <View style={styles.contentCompact}>
                    <View style={[styles.iconContainer, { backgroundColor: colors.warning + '20' }]}>
                        <Crown size={16} color={colors.warning} />
                    </View>
                    <Text style={[styles.textCompact, { color: colors.text }]}>
                        <Text style={{ fontWeight: 'bold' }}>Seja Premium:</Text> Rachas ilimitados!
                    </Text>
                </View>
                <ArrowRight size={16} color={colors.primary} />
            </TouchableOpacity>
        );
    }

    return (
        <TouchableOpacity
            style={[styles.container, { backgroundColor: colors.surface, borderColor: colors.warning }]}
            onPress={handlePress}
            activeOpacity={0.9}
        >
            <View style={styles.header}>
                <View style={[styles.iconContainerLarge, { backgroundColor: colors.warning + '20' }]}>
                    <Crown size={24} color={colors.warning} />
                </View>
                <View style={styles.textContainer}>
                    <Text style={[styles.title, { color: colors.text }]}>Premium Anual 👑</Text>
                    <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
                        Apenas R$ 9,90/ano. Liberdade total.
                    </Text>
                </View>
            </View>

            <View style={[styles.button, { backgroundColor: colors.primary }]}>
                <Text style={styles.buttonText}>Conhecer Vantagens</Text>
                <ArrowRight size={16} color="#FFF" />
            </View>
        </TouchableOpacity>
    );
}

const styles = StyleSheet.create({
    container: {
        padding: 16,
        borderRadius: 16,
        borderWidth: 1,
        marginVertical: 16,
        marginHorizontal: 16, // Added margin to prevent edge sticking
        gap: 16,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
    },
    iconContainerLarge: {
        padding: 10,
        borderRadius: 12,
    },
    textContainer: {
        flex: 1,
    },
    title: {
        fontSize: 18,
        fontFamily: 'Inter-Bold',
        marginBottom: 4,
    },
    subtitle: {
        fontSize: 14,
        fontFamily: 'Inter-Regular',
    },
    button: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 12,
        borderRadius: 12,
        gap: 8,
    },
    buttonText: {
        color: '#FFF',
        fontSize: 16,
        fontFamily: 'Inter-SemiBold',
    },

    // Compact Styles
    containerCompact: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 12,
        borderRadius: 12,
        borderWidth: 1,
        marginVertical: 8,
        marginHorizontal: 16, // Added margin to prevent edge sticking
    },
    contentCompact: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    iconContainer: {
        padding: 6,
        borderRadius: 8,
    },
    textCompact: {
        fontSize: 14,
        fontFamily: 'Inter-Medium',
    },
});
